import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { SxProps, Theme } from "@mui/material";
import TextField from "@mui/material/TextField";

type DatePickerProps = {
  disableFuture?: boolean;
  className?: string;
  fullWidth?: boolean;
  size?: "medium" | "small";
  sx?: SxProps<Theme>;
  label: string;
  value?: Date | string;
  onChange: (value: string | Date | null, keyboardInputValue?: string) => void;
};

export function DatePicker({
  className,
  fullWidth,
  label,
  value,
  size,
  sx,
  onChange,
  disableFuture,
}: DatePickerProps) {
  return (
    <MuiDatePicker
      disableFuture={disableFuture}
      className={className}
      label={label}
      value={value}
      onChange={onChange}
      renderInput={(params) => (
        <TextField fullWidth={fullWidth} size={size} sx={sx} {...params} />
      )}
    />
  );
}
